import store from "../../../redux/store";
import { handleSelectResources } from "./fileManager.actions";

export function handleOnSelectoSelect(e: any) {
    e.selected.forEach((el: any) => {
        if (el.offsetParent) el.offsetParent.classList.add("!border-primary-600");
    });
    e.removed.forEach((el: any) => {
        if (el.offsetParent) el.offsetParent.classList.remove("!border-primary-600");
    });
}

export function handleOnSelectoSelectEnd(e: any) {
    const fileManager = store.getState().fileManager;
    const ids = e.selected.map((el: any) => parseInt(el.dataset.resourceId));
    const selectedResources = fileManager.filteredResources.filter((resource) => {
        return ids.includes(resource.id);
    });
    handleSelectResources([...selectedResources]);
}

export function handleOnSelectoScroll(e: any, ref: any) {
    ref.current.scrollBy(e.direction[0] * 10, e.direction[1] * 10);
}

export const selectorCommonProps = {
    container: document.body,
    dragContainer: "#fileManager",
    selectableTargets: ["#resources .resource"],
    selectByClick: false,
    selectFromInside: false,
    continueSelect: false,
    keyContainer: window,
    hitRate: 1,
    onSelect: handleOnSelectoSelect,
    onSelectEnd: handleOnSelectoSelectEnd
};
